import React, { FC, useEffect, useRef } from 'react';

interface VideoProps {
  source: string;
  width: number;
  height: number;
  autoplay?: boolean;
  className?: string;
  preload?: 'none' | 'metadata' | 'auto';
  onMouseOver?: () => void;
  onMouseLeave?: () => void;
}

const Video: FC<VideoProps> = ({
  source,
  width,
  height,
  autoplay,
  preload,
  className,
  onMouseOver,
  onMouseLeave,
}) => {
  const videoRef = useRef<any>();

  useEffect(() => {
    if (videoRef.current && autoplay) {
      videoRef.current.play();
    }
  }, [videoRef.current]);

  return (
    <video
      loop
      muted
      autoPlay
      width={width}
      ref={videoRef}
      height={height}
      controls={false}
      preload={preload}
      playsInline={true}
      className={className}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
    >
      <source src={source} type="video/mp4" />
      <source src={source} type="video/webm" />
      Your browser does not support the video tag.
    </video>
  );
};

export default Video;
